package co.maytes.standupbot.dashboard.features.home

import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.billing.BillingStatusDto
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.dto.standup.UnlinkedPeopleDto
import co.maytes.standupbot.shared.dto.standuprun.StandupRunSummaryDto
import co.maytes.standupbot.shared.dto.workspace.WorkspaceMemberDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object HomeContract {
    sealed interface Status {
        data object Loading : Status
        data object Ready : Status
        data class Error(val error: ApiError) : Status
    }

    data class State(
        val workspaceId: String = "",
        val canManage: Boolean = false,
        val status: Status = Status.Loading,
        val runs: List<StandupRunSummaryDto> = emptyList(),
        val standups: List<StandupDto> = emptyList(),
        val billingStatus: BillingStatusDto? = null,
        val members: List<WorkspaceMemberDto>? = null,
        val unlinked: UnlinkedPeopleDto? = null,
    ) : MVIState

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String, val canManage: Boolean = false) : Intent
        data class ViewRun(val runId: String) : Intent
        data object ViewAllRuns : Intent
        data object ManageStandups : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
    }
}
